export const requestState = { loading: true, error: false, success: false }
